import type { ChatEvents } from './chat'
import type { ModerationEvents } from './moderation'

export type AIEvents = ChatEvents & ModerationEvents

export type { ChatEvents } from './chat'
export type { ModerationEvents } from './moderation'
export type {
  AiInputMethod,
  AiSubmissionMethod,
  AiFeedbackUiElement,
  AiRecommendationPayload,
} from './chat'
// Runtime const (canonical Title Case input_method values) — value, not type.
export { AI_INPUT_METHOD } from './chat'
